import * as React from 'react';
import Helmet from '../../../commonComponents/Helmet';
import AutoLogoutLayout from '../common/Layout';
import { loginPageUrl } from '../../../core/constants';
import { SignUpV2Forms } from '../../../core/enums';
import RegisterForm from './forms/RegisterForm';
import PasswordForm from './forms/PasswordForm';
import OfficePartnerForm from './forms/OfficePartnerForm';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';
import RegisterCompletionForm from './forms/RegisterCompletionForm';

const RegisterPage = () => {
	const navigate = useNavigateWithAppName();

	const [currentStep, setCurrentStep] = React.useState(1);
	const [totalSteps, setTotalSteps] = React.useState(1);
	const [activeForm, setActiveForm] = React.useState(SignUpV2Forms.SignUpForm);
	const [showSignUpForm, setShowSignUpForm] = React.useState(true);
	const [showPasswordForm, setShowPasswordForm] = React.useState(false);
	const [showOfficePartnerForm, setShowOfficePartnerForm] = React.useState(false);
	const [showSignUpCompletionForm, setShowSignUpCompletionForm] = React.useState(false);

	React.useEffect(() => {
		const steps = Object.keys(SignUpV2Forms).length / 2;
		setTotalSteps(steps);
	}, []);

	const showForm = (nextForm: SignUpV2Forms) => {
		setActiveForm(nextForm);
		setShowSignUpForm(nextForm === SignUpV2Forms.SignUpForm);
		setShowPasswordForm(nextForm === SignUpV2Forms.PasswordForm);
		setShowOfficePartnerForm(nextForm === SignUpV2Forms.OfficeAndPartnerForm);
		setShowSignUpCompletionForm(nextForm === SignUpV2Forms.SignUpCompletionForm);
	};

	const handleSignUpFormSubmission = () => {
		showForm(SignUpV2Forms.PasswordForm);
		setCurrentStep(currentStep + 1);
	};

	const handlePasswordFormSubmission = () => {
		showForm(SignUpV2Forms.OfficeAndPartnerForm);
		setCurrentStep(currentStep + 1);
	};

	const handleOfficePartnerFormSubmission = () => {
		showForm(SignUpV2Forms.SignUpCompletionForm);
		setCurrentStep(currentStep + 1);
	};

	const handleBackButtonClick = () => {
		if (currentStep > 1) {
			setCurrentStep((prevStep) => prevStep - 1);
		}

		switch (activeForm) {
			case SignUpV2Forms.PasswordForm:
				showForm(SignUpV2Forms.SignUpForm);
				break;
			case SignUpV2Forms.OfficeAndPartnerForm:
				showForm(SignUpV2Forms.PasswordForm);
				break;
			case SignUpV2Forms.SignUpCompletionForm:
				showForm(SignUpV2Forms.OfficeAndPartnerForm);
				break;
			default:
				navigate(loginPageUrl);
		}
	};

	return (
		<AutoLogoutLayout
			headerText="Create a new account"
			onBackButtonClick={handleBackButtonClick}
			currentStep={currentStep}
			totalStep={totalSteps}
			colour="blue"
			showFooter
		>
			<Helmet>
				<title>Sign Up</title>
			</Helmet>
			{showSignUpForm && <RegisterForm onSubmit={handleSignUpFormSubmission} />}
			{showPasswordForm && <PasswordForm onSubmit={handlePasswordFormSubmission} />}
			{showOfficePartnerForm && <OfficePartnerForm onSubmit={handleOfficePartnerFormSubmission} />}
			{showSignUpCompletionForm && <RegisterCompletionForm />}
		</AutoLogoutLayout>
	);
};

export default RegisterPage;
